<!-- Main container -->
<div class="layout-col full pt-sm">
  <elder-table
    class="flex"
    matSort
    [data]="data"
    [idField]="'id'"
    (itemClick)="openDetail($event)"
    [selectionVisible]="true"
    [selectionMultiEnabled]="true"
  >
    <elder-data-toolbar *elderTableToolbar [canRemove]="false" [canAdd]="false" [canMore]="false">
      <!-- Advanced search -->
      <ng-template elderToolbarContent="center">
        <elder-search-box
          class="flex-60 pt-xs"
          dense
          queryKey="query"
          [autoPanel]="false"
          [elderSearchContext]="data.filter"
          [forcedFilters]="forcedFilters$ | async"
        >
        </elder-search-box>
      </ng-template>

      <ng-template elderToolbarContent="right.actions" let-selection>
        <button
          mat-icon-button
          color="primary"
          (click)="openBatchCommand(selection)"
          [disabled]="!selection.length"
        >
          <mat-icon>keyboard_command_key</mat-icon>
        </button>
      </ng-template>
    </elder-data-toolbar>

    <!-- editEnabled Column -->
    <ng-container matColumnDef="editEnabled">
      <th mat-header-cell *matHeaderCellDef style="width: 5px"></th>
      <td mat-cell *matCellDef="let order">
        <mat-icon>
          {{ isProcessable(order) ? 'lock_open' : 'lock' }}
        </mat-icon>
      </td>
    </ng-container>

    <!-- id Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.id' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">{{ order.id }}</td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
        {{ 'context.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">
        <div class="layout-col place-center-start">
          <span>{{ order.description }}</span>
          <span class="text-body-small">{{ order.projectDescription }}</span>
        </div>
      </td>
    </ng-container>

    <!-- facility Column -->
    <ng-container matColumnDef="facility">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'context.facility' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">{{ order.company }} / {{ order.facility }}</td>
    </ng-container>

    <!-- state Column -->
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="confirmationState">
        {{ 'orders.prod.confirmation' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">
        <span>{{ 'order_confirmation_state.' + order.confirmationState | translate }}</span>
      </td>
    </ng-container>

    <!-- completion / production state Column -->
    <ng-container matColumnDef="completion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="completionState">
        {{ 'context.production' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">
        <span>{{ 'work_order_completion_state.' + order.completionState | translate }}</span>
      </td>
    </ng-container>

    <!-- groupId Column -->
    <ng-container matColumnDef="groupId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'orders.group' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">{{ order.groupId }}</td>
    </ng-container>

    <!-- deliveryInterval Column -->
    <ng-container matColumnDef="deliveryInterval">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="deliveryInterval.start">
        {{ 'orders.deliveryDate' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">
        {{ (order?.deliveryInterval | isoIntervalParse)?.start?.toString() | date: 'dd.MM.yyyy' }}
      </td>
    </ng-container>

    <!-- createdAt -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.createdAt' | translate }}
      </th>
      <td mat-cell *matCellDef="let order">
        {{ order.createdAt | date: 'short' }}
      </td>
    </ng-container>

    <!-- labels Column -->
    <ng-container matColumnDef="labels">
      <th mat-header-cell *matHeaderCellDef>Labels</th>
      <td mat-cell *matCellDef="let order">
        <mat-chip-set>
          @for (label of displayLabels(order.labels); track label) {
            <mat-chip highlighted>{{ label }}</mat-chip>
          }
        </mat-chip-set>
      </td>
    </ng-container>
  </elder-table>
</div>
